const TASK_API_URLS = {
  INSERT_DSC_TASK: "/taskapi/insert_cert",
  REGISTER_DSC_TASK: "/taskapi/register_cert",
  INSERT_SIGN_TASK: "/taskapi/insert_sign",
  GET_HASH_SIGN: "/taskapi/get_digi_hash",
  EMBED_HASH: "/taskapi/embed_hash",
  REGISTER_DSC:"/taskapi/add_dsc",
  GET_ALL: "/dsc/get_all",
  UPDATE: "/dsc/update",
  INSERT: "/dsc/insert",
  GET_ONE: "/taskapi/get_task",
  DELETE: "/dsc/delete_one",
};

export { TASK_API_URLS };

